import { type Matchup } from '@pff-consumer/schema/sdk/matchups'

export const getSelectedPlayerMatchups = (matchups: Matchup[] | undefined, playerId: number) => {
  if (!matchups?.length || !playerId) {
    return null
  }

  return matchups.find((matchup) => matchup.player.id === playerId) || null
}
